export default function BillingInfo() {
  return (
    <aside className="lg:col-span-7 space-y-4">
      <div className="border border-zinc-800 p-6">
        <div className="overline mb-3 neon-text">WHAT PRO UNLOCKS</div>
        <ul className="space-y-2 text-sm text-zinc-300">
          <li>· Unlimited AI handicapper plays (MLB / NBA / NHL / NFL / UFC)</li>
          <li>· Weekly top-rated Martingale picks</li>
          <li>· Arbitrage scanner — locked-in edge opportunities</li>
          <li>· Morning email digest at your chosen hour</li>
          <li>· Full 2025 + 2026 team series analysis</li>
        </ul>
      </div>
      <div className="border border-zinc-800 p-6">
        <div className="overline mb-3">HOW WEEKLY BILLING WORKS</div>
        <ol className="space-y-2 text-sm text-zinc-400 leading-relaxed list-decimal list-inside">
          <li>Add a card via Stripe checkout. Your trial stays free for 3 days.</li>
          <li>Each payment extends your Pro window by 7 days.</li>
          <li>
            Don't renew? Your access ends at the end of the current week — no auto-charges
            beyond what you've already paid.
          </li>
          <li>Secured by Stripe — we never see or store your card number.</li>
        </ol>
      </div>
    </aside>
  );
}
